import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { EmployeeLanguageConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { LanguageService } from './api/language.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class EmployeeLanguageApiModule {
    public static forRoot(configurationFactory: () => EmployeeLanguageConfiguration): ModuleWithProviders<EmployeeLanguageApiModule> {
        return {
            ngModule: EmployeeLanguageApiModule,
            providers: [ { provide: EmployeeLanguageConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: EmployeeLanguageApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('EmployeeLanguageApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
